import React from 'react';
import { Paper, Typography, Checkbox, FormControlLabel, Box } from '@mui/material';

function DropZone({ dragActive, onDragEnter, onDragLeave, onDragOver, onDrop, validateAccessibility, onValidateAccessibilityChange }) {
  return (
    <Paper
      sx={{
        p: 6,
        mb: 4,
        border: dragActive ? '3px dashed #1976d2' : '2px dashed #ccc',
        backgroundColor: dragActive ? 'rgba(25, 118, 210, 0.05)' : 'transparent',
        transition: 'all 0.3s ease',
        textAlign: 'center',
        cursor: 'pointer',
      }}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <Typography variant="h5" gutterBottom color={dragActive ? 'primary' : 'text.secondary'}>
        {dragActive ? 'Drop PDF or XML here' : 'Drag & Drop PDF'}
      </Typography>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={validateAccessibility}
              onChange={(e) => onValidateAccessibilityChange(e.target.checked)}
              color="primary"
            />
          }
          label="Validate PDF Accessibility (PDF/UA-1)"
        />
      </Box>
    </Paper>
  );
}

export default DropZone;